import { api } from "../adapters/api";
import { FeedbackRequest } from "../pages/applicationCandidate/feedbackRequest";
import { InvitationRequest, UpdateApplicationStatusRequest } from "../pages/candidate/InvitationRequest";

const resource: string = "api/v1";

export const createInvitation = (invitation: InvitationRequest) => api.post(resource + "/applications/invitation", JSON.stringify(invitation), {"Authorization": "Bearer " + localStorage.getItem("jwtToken")});

export const updateApplicationStatus = (applicationUpdateRequest: UpdateApplicationStatusRequest, applicationId: string) => api.patch(resource + "/applications/" + applicationId, JSON.stringify(applicationUpdateRequest), {"Authorization": "Bearer " + localStorage.getItem("jwtToken")});

export const sendFeedback = (feedbackRequest: FeedbackRequest) => api.post(resource + "/feedback", JSON.stringify(feedbackRequest), {"Authorization": "Bearer " + localStorage.getItem("jwtToken")});